import React from 'react'
import {connect} from 'react-redux'
import {compose, lifecycle} from 'recompose'
import TabList from '../common/helpers/TabList'
import {setJumbotronTitle} from '../../actions/common'
import MapOverview from '../../panel-admin/map-charts/MapOverview'
import MapManage from '../../panel-admin/map-charts/MapManage'
import {checkPermission} from '../common/functions/permissions'
import {
  PERMISSION_MAP_CHARTS_WRITE,
  PERMISSION_VACANCIES_READ
} from '../../constants'


const mapStateToProps = (state, ownProps) => ({

})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle('Map charts')) },

})

const MapCharts = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.fetchGeo();
    },
    componentDidUpdate(prevProps) {

    },
    fetchGeo() {
      this.props.setJumbotronTitle('Map charts');
      checkPermission(PERMISSION_MAP_CHARTS_WRITE) ?
      this.setState({
       contentItems: [
         {
           label: 'Overview',
           link: 'overview',
           content: <MapOverview/>
         },
         {
           label: 'Manage',
           link: 'manage',
           content: <MapManage history={this.props.history} />
         }
       ]
     })
     :
     this.setState({
      contentItems: [
        {
          label: 'Overview',
          link: 'overview',
          content: <MapOverview/>
        }
      ]
    })

    }
  })
)

export default MapCharts(TabList)
